import { CognitoCredentials } from './cognito-creds/cognito-creds.state';
import { createFeatureSelector } from '@ngrx/store';
import { UserState } from './user/user.state';

export const selectCognitoCredentials =
  createFeatureSelector<CognitoCredentials>('cognitoCredentials');

export const selectUser = createFeatureSelector<UserState>('user');

